import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=3606ceec&scoped=true"
var script = {}
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=3606ceec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3606ceec",
  null
  
)

export default component.exports